import React from 'react';
import { shadeSafe, tintSafe } from '../../../CodesThatsGottaGoSomewhereElse';
import { LFC } from '../../../Legacy';
import { Icon } from '../../../concepts/resources/Icon';
import { Colors } from '../../../ui';
import { RoadmapCard } from '../../packages/paper/RoadmapCard';
import { RenderComments, RenderTags } from './RenderAnnotations';
import { RenderBorder, RenderBounds, RenderGraffiti, usePose } from './RenderHelpers';
import { RenderText } from './RenderText';

const RenderBox: LFC<any> = ({ children, ...props }) => {
    return <div style={{ position: 'absolute', ...props }}>{children}</div>;
};

const RenderOriginal = ({ object }: { object: RoadmapCard }) => {
    const { background, layout } = object;
    const border = `solid 4px ${shadeSafe(.05, background)}`;
    return <>
        <RenderBox {...layout.original.toCSS()} background={background} border={border} borderRadius="10px" />
    </>;
};

const RenderAdjusted = ({ object }: { object: RoadmapCard }) => {
    const { punctuality, background, layout } = object;
    if (punctuality === 'ontime') return null;

    const border = `solid 4px ${shadeSafe(.05, background)}`;
    const backgroundImage = punctuality === 'early'
        ? `repeating-linear-gradient(
            -45deg,
            ${tintSafe(.6, background)},
            ${tintSafe(.6, background)} 10px,
            ${tintSafe(.8, background)} 10px,
            ${tintSafe(.8, background)} 20px
        `
        : `repeating-linear-gradient(
            -45deg,
            ${shadeSafe(.05, background)},
            ${shadeSafe(.05, background)} 10px,
            ${shadeSafe(.2, background)} 10px,
            ${shadeSafe(.2, background)} 20px
        `;

    return <>
        <RenderBox {...layout.adjusted.toCSS()} backgroundImage={backgroundImage} border={border} borderRadius="10px">
        </RenderBox>
    </>;
};

const RenderInner = ({ object }: { object: RoadmapCard }) => {
    // const peers = ZonePeersAttr.get(object);
    // const color = !!object.autoColor ? tintSafe(.5, object.autoColor) : '#ddd';
    // const { border, layout } = object;
    // const base = layout.base

    const { background, style } = object;
    const border = `solid 4px ${shadeSafe(.05, background)}`;

    return <>
        <RenderBox inset="0" background={background} border={border} borderRadius="10px" />
        {/* {style === 'solid' && <RenderBox inset="0" background={tintSafe(.5, background)} />}
        {style === 'dashed' && <RenderBox inset="0" background={tintSafe(.75, background)} border={`dashed 4px ${tintSafe(.5, background)}`} />} */}
    </>;
};

const RenderOverage = ({ object }: { object: RoadmapCard }) => {
    // const peers = ZonePeersAttr.get(object);
    // const color = !!object.autoColor ? tintSafe(.5, object.autoColor) : '#ddd';
    const { overage } = object.layout;
    const { background, style } = object;
    if (!overage.width || !overage.height) return null;

    // const backgroundImage = `repeating-linear-gradient(
    //     -45deg,
    //     ${shadeSafe(.1, background)},
    //     ${shadeSafe(.1, background)} 10px,
    //     ${shadeSafe(.12, background)} 10px,
    //     ${shadeSafe(.12, background)} 20px
    //   `;

    const backgroundImage = `repeating-linear-gradient(
        -45deg,
        ${shadeSafe(.05, background)},
        ${shadeSafe(.05, background)} 10px,
        ${shadeSafe(.1, background)} 10px,
        ${shadeSafe(.1, background)} 20px
      `;

    const inset = overage.extend(0, -4, -4, -4);

    return <>
        <RenderBox {...inset.toCSS()} backgroundImage={backgroundImage} borderRadius="0 6px 6px 0" />
    </>;
};

const RenderUnderage = ({ object }: { object: RoadmapCard }) => {
    // const peers = ZonePeersAttr.get(object);
    // const color = !!object.autoColor ? tintSafe(.5, object.autoColor) : '#ddd';
    const { underage } = object.layout;
    const { background, style } = object;
    if (!underage.width || !underage.height) return null;

    const backgroundImage = `repeating-linear-gradient(
        -45deg,
        ${tintSafe(.8, background)},
        ${tintSafe(.8, background)} 10px,
        ${tintSafe(.8, background)} 10px,
        ${tintSafe(.8, background)} 20px
      `;

    const inset = underage.extend(0, -4, -4, -4);

    return <>
        <RenderBox {...inset.toCSS()} backgroundImage={backgroundImage} borderRadius="0 6px 6px 0">
            {/* <RenderBox {...centered} background={background} padding="2px 4px" fontWeight="500" fontFamily="Rubik" borderRadius="4px" color={tintSafe(.8, background)}>
                EARLY
            </RenderBox> */}
        </RenderBox>
    </>;
};

// const RenderLabel = ({ object }: { object: RoadmapCard }) => {
//     // const peers = ZonePeersAttr.get(object);
//     // const color = !!object.autoColor ? tintSafe(.5, object.autoColor) : '#ddd';
//     // const { border, layout } = object;
//     // const base = layout.base

//     const area = object.layout.label;
//     const { background } = object.field('label') as RoadmapCardLabel;

//     return <>
//         <RenderBox {...area.toCSS()} background={background} borderRadius="16px" />
//         <RenderTextField object={object} name="label" customStyle={{ color: '#fff' }} />
//     </>
// };

const RenderExternalLink = ({ object }: { object: RoadmapCard }) => {
    // const peers = ZonePeersAttr.get(object);
    // const color = !!object.autoColor ? tintSafe(.5, object.autoColor) : '#ddd';
    // const { border, layout } = object;
    // const base = layout.base
    const { interaction, pressed } = usePose(object);
    const area = object.layout.externalLink;
    const hover = interaction?.type === 'invoke' && interaction?.hint === 'externalLink';
    const base = object.background;
    const active = hover && pressed;
    const background = active ? tintSafe(.05, base) : (hover ? tintSafe(.15, base) : tintSafe(.25, base));

    if (!area.width || !area.height) return null;

    return <>
        <RenderBox {...area.toCSS()} background={background} borderRadius="8px" display="flex" alignItems="center" justifyContent="center" gap="4px">
            <Icon size="24px" src="deqo://icons/hero/external-link" color={Colors.text} />
            <RenderBox position="relative" color={Colors.text} fontWeight="500">EXTERNAL LINK</RenderBox>
        </RenderBox>
    </>;
};

export const RoadmapCardVisual: LFC<{ object: RoadmapCard }> = ({ object, children }) => {

    const pose = usePose(object);
    const { beingEdited } = pose;

    const borderStyling = {
        width: object.width,
        height: object.height,
    };

    return <>
        <RenderBounds object={object}>
            <RenderBorder pose={pose} style={borderStyling}>
                <RenderAdjusted object={object} />
                <RenderOriginal object={object} />
                {/* <RenderInner object={object} />
                <RenderOverage object={object} />
                <RenderUnderage object={object} /> */}
                <RenderGraffiti object={object} />
                {!beingEdited && <RenderText {...object.layout.label} value={object.label} formatOpts={['mention']} />}
                <RenderExternalLink object={object} />
                <RenderComments object={object} />
                <RenderTags object={object} textSettings={{ fontSize: object.height < 80 ? 12 : 16 }} />
            </RenderBorder>
        </RenderBounds>
        {children}
    </>;
};
